export default __webpack_public_path__ + "static/media/yakuniy_davlat_attestatsiyasi.b97a80c9.pdf";